import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MessageService } from '../message.service';
import { Subscription } from 'rxjs';
import { RestApiService } from '../rest-api.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { SocketService } from '../socket.service';
import { JsonPipe } from '@angular/common';

@Component({
    selector: 'app-dashboard-tcs',
    templateUrl: './dashboard-tcs.component.html',
    styleUrls: ['./dashboard-tcs.component.css']
})
export class DashboardTcsComponent implements OnInit, OnDestroy {
    isCollapsed: boolean;
    // clientId: number;
    clientName: string;
    userGroups: any;
    userGroupId: number;
    groupName: string;
    grpLevel: number;
    respObject: any;
    tilesData = [];
    isLabel0: boolean;
    isLabel1: boolean;
    isLabel2: boolean;
    isLabel3: boolean;
    islead: boolean;
    cat1: any;
    cat2: any;
    cat3: any;
    cat4: any;
    private userAuth: Subscription;
    private ticketSub: Subscription;
    userGroupSelected: number;
    private ticketType: number;
    ticketTypeLoaded = false;
    radioButton = [];
    selectedData = [];
    private notifier: NotifierService;
    hideChart: boolean;
    modal: any;
    radius: number;
    clientId: number;
    categories = [];
    categorySelected: number;
    errorMessage: string;
    isError = false;
    users = [];
    userSelected: number;
    @ViewChild('content') content;
    @ViewChild('clientSelect') private clientSelect;
    private dashboardSubscribe: Subscription;
    isLoading: boolean;
    workType: string;
    workspaces = [];
    typeSeq: number;
    isAdmin: boolean;
    private ticketType1: number;
    load: boolean;
    urlKeys = [];
    showScheduleTicket: boolean;
    showCreateTicket: boolean;
    showFaq: boolean;
    showSearch: boolean;
    CREATE_TICKET_URL_KEY_ID = 5;
    SCHEDULE_TICKET_URL_KEY_ID = 7;
    FAQ_URL_KEY_ID = 3;
    SEARCH_URL_KEY_ID = 4;
    subClients = [];
    clientSelected: number;
    private dialogRef: MatDialogRef<any, any>;
    groups = [];
    groupSelected: number;
    masterClientId: number;
    allSelected: boolean;
    masterSupportGroupId: number;

    constructor(private messageService: MessageService, private _rest: RestApiService,
        private actRoute: ActivatedRoute, private route: Router, notifier: NotifierService,
        private modalService: NgbModal, private socketService: SocketService, private dialog: MatDialog) {
        this.notifier = notifier;
        this.dashboardSubscribe = this.socketService.dashboardSubject.subscribe((data) => {
            if (this.userGroupId === data.groupId) {
                // console.log('-->: ' + JSON.stringify(data));
                const menuId = data.menuId;
                const displayelem = document.getElementById('display_' + menuId);
                if (displayelem !== undefined && displayelem !== null) {
                    displayelem.classList.remove('none');
                }
                const countelem = document.getElementById('count_' + menuId);
                if (countelem !== undefined && countelem !== null) {
                    countelem.innerText = (Number(countelem.innerText) + 1) + '';
                }
            }
        });
    }

    ngOnInit() {
        this.masterClientId = 0;
        this.isAdmin = false;
        this.showScheduleTicket = true;
        this.showCreateTicket = true;
        this.showFaq = true;
        this.showSearch = true;
        this.typeSeq = 0;
        this.isLoading = false;
        this.radius = 65;
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.isLabel3 = false;
        this.islead = false;
        this.hideChart = true;
        this.categorySelected = 0;
        this.userSelected = 0;
        this.actRoute.queryParams.subscribe(params => {
            const token = params['token'];
            this.clientId = params['clientId'];
            this.masterClientId = this.clientId;
            const userId = params['userId'];
            const encodedUserName = params['name'];
            let userName;
            if (encodedUserName) {
                userName = this.messageService.xorEncode(atob(encodedUserName), this.messageService.SECRET_TOKEN);
            }
            const sourceType = params['srcType'];
            let callback = params['callback'];
            if (this.clientId !== undefined && token !== undefined && userName !== undefined) {
                // // console.log('from panel');
                if (callback === 'undefined' || callback === undefined || callback === '') {
                    callback = this.messageService.API_ROOT;
                }
                if (sourceType !== 'undefined' && sourceType !== undefined && sourceType !== '') {
                    this.messageService.saveSourceType(sourceType);
                }
                this.messageService.clearSession();
                const data = { clientId: this.clientId, token: token, loginName: userName };

                this._rest.tokenValidation(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.messageService.addSessionData(this.respObject.details, token, this.clientId);
                        this.messageService.tokenSubject.next();
                        sessionStorage.removeItem('dd');
                        this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                            this.clientName = auth[0].client;
                            this.userGroups = auth[0].groupId;
                            if (this.userGroups !== undefined) {
                                this.userGroupId = this.userGroups[0].groupId;
                                this.groupName = this.userGroups[0].grpName;
                                this.grpLevel = this.userGroups[0].level;
                            }
                            this.userGroupSelected = this.userGroupId;
                            this.masterSupportGroupId = this.userGroupId;
                            this.onPageLoad();
                        });
                    } else {
                        this.messageService.clearSession();
                        alert(this.messageService.URL_TOKEN_ERROR1);
                        window.location.href = callback;
                    }
                }, (err) => {
                    this.messageService.clearSession();
                    alert(this.messageService.TOKEN_TIMEOUT_ERROR);
                    window.location.href = callback;
                });
                // }
            } else if (token !== undefined && userId !== undefined) {
                this.messageService.addSessionData(this.messageService.xorEncode(atob(userId), this.messageService.SECRET_TOKEN), token, this.clientId);
                this.messageService.tokenSubject.next();
                sessionStorage.removeItem('dd');
                this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                    this.clientName = auth[0].client;
                    this.clientId = auth[0].clientId;
                    this.masterClientId = this.clientId;
                    this.userGroups = auth[0].groupId;
                    if (this.userGroups !== undefined) {
                        this.userGroupId = this.userGroups[0].groupId;
                        this.groupName = this.userGroups[0].grpName;
                        this.grpLevel = this.userGroups[0].level;
                    }
                    this.userGroupSelected = this.userGroupId;
                    this.masterSupportGroupId = this.userGroupId;
                    this.onPageLoad();
                });
            } else {
                if (this.messageService.getUserId() === null || this.messageService.getToken() === null) {
                    this.messageService.clearSession();
                    window.location.href = this.messageService.API_ROOT;
                } else {
                    // this.sourceType = 'web';
                    if (this.messageService.clientId) {
                        this.clientId = this.messageService.clientId;
                        this.masterClientId = this.clientId;
                        this.clientName = this.messageService.client;
                        this.userGroups = this.messageService.groupId;

                        if (this.userGroups !== undefined) {
                            if (this.messageService.getSupportGroup() === null) {
                                this.userGroupId = this.userGroups[0].groupId;
                                this.groupName = this.userGroups[0].grpName;
                                this.grpLevel = this.userGroups[0].level;
                            } else {
                                const group = this.messageService.getSupportGroup();
                                this.userGroupId = group.groupId;
                                this.groupName = group.grpName;
                                this.grpLevel = group.level;
                            }
                            this.userGroupSelected = this.userGroupId;
                            this.masterSupportGroupId = this.userGroupId;
                        }
                        // console.log('-----within page-------');
                        this.onPageLoad();
                    } else {
                        this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                            this.clientId = auth[0].clientId;
                            this.masterClientId = this.clientId;
                            this.clientName = auth[0].client;
                            this.userGroups = auth[0].groupId;
                            if (this.userGroups !== undefined) {
                                if (this.messageService.getSupportGroup() === null) {
                                    this.userGroupId = this.userGroups[0].groupId;
                                    this.groupName = this.userGroups[0].grpName;
                                    this.grpLevel = this.userGroups[0].level;
                                } else {
                                    const group = this.messageService.getSupportGroup();
                                    this.userGroupId = group.groupId;
                                    this.groupName = group.grpName;
                                    this.grpLevel = group.level;
                                }
                                this.userGroupSelected = this.userGroupId;
                                this.masterSupportGroupId = this.userGroupId;
                            }
                            // console.log('-----page refresh-------');
                            console.log('group level=====' + this.grpLevel);
                            this.onPageLoad();
                            // }
                        });
                    }
                }
            }
        });
        // -------------------------------------------------
        // console.log('group level=====' + this.grpLevel);
        // window.addEventListener('click', function (event) {
        //     // console.log('AAAAAAAAAAAA==========', this.modal.close());
        // });
    }

    onPageLoad() {
        // console.log(' ---- log -------');
        // const ticketType = 32;
        // // console.log('group level===============', this.grpLevel, this.ticketType;
        console.log(JSON.stringify(this.messageService.groupId));
        this.isLoading = true;
        this.tilesData = [];
        if (this.userGroupId) {
            // if (this.grpLevel === 0 ) {
            //     this.workspaces = [{id: '1', name: 'My Workspace'}];
            // } else {
            //     this.workspaces = [{id: '1', name: 'My Workspace'}, {id: '2', name: 'Team Workspace'}];
            // }
            // this.workType = '1';
            this.ticketSub = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
                this.respObject = res1;
                this.ticketTypeLoaded = true;
                if (this.respObject.success) {
                    this.radioButton = this.respObject.details;
                    const storage = JSON.parse(sessionStorage.getItem('dd'));
                    this.radioButton[0].checked = false;
                    if (storage === null) {
                        this.categorySelected = 0;
                        this.userSelected = 0;
                        if (this.radioButton.length === 1) {
                            this.ticketType = this.radioButton[0].id;
                            // console.log("id"+ this.ticketType);
                            this.radioButton[0].checked = true;
                            this.typeSeq = this.radioButton[0].seq;
                        } else {
                            for (let i = 0; i < this.radioButton.length; i++) {
                                if (this.radioButton[i].view_sequence === 2) {
                                    this.ticketType = this.radioButton[i].id;
                                    // console.log("id"+ this.ticketType);
                                    this.radioButton[i].checked = true;
                                    this.typeSeq = this.radioButton[i].seq;
                                    break;
                                }
                            }
                        }
                        this.messageService.saveMenuData({
                            type: this.ticketType,
                            seq: this.typeSeq,
                            user: this.userSelected,
                            cat: this.categorySelected
                        });
                    } else {
                        const type = storage.type;
                        // console.log("type  "+type);
                        this.typeSeq = storage.seq;
                        this.load = false;
                        for (let i = 0; i < this.radioButton.length; i++) {
                            if (this.radioButton[i].id === type) {
                                // console.log("type"+type);
                                this.ticketType = this.radioButton[i].id;
                                // console.log("id"+ this.ticketType);
                                this.load = true;
                                // this.typeSeq = this.radioButton[i].seq;
                                this.radioButton[i].checked = true;
                                break;
                            }
                        }
                        if (!this.load) {
                            for (let i = 0; i < this.radioButton.length; i++) {
                                if (this.radioButton[i].view_sequence === 2) {
                                    this.ticketType = this.radioButton[i].id;
                                    // console.log("idddddd"+ this.ticketType);
                                    this.radioButton[i].checked = true;
                                    // this.typeSeq = this.radioButton[i].seq;
                                    break;
                                }
                            }
                        }
                        this.categorySelected = storage.cat;
                        this.userSelected = storage.user;
                    }
                    // console.log(this.typeSeq)
                    if (this.grpLevel === 0 || this.typeSeq === 2) {
                        this.workspaces = [{ id: '1', name: 'My Workspace' }];
                    } else {
                        this.workspaces = [{ id: '1', name: 'My Workspace' }, { id: '2', name: 'Team Workspace' }];
                    }
                    // this.workType = '1';
                    this._rest.checkIsLead(this.masterClientId, this.masterSupportGroupId, this.messageService.getUserId()).subscribe((res3) => {
                        this.respObject = res3;
                        if (this.respObject.success) {
                            this.islead = false;
                            // this.islead = this.respObject.details[0].is_spoc;
                            // // console.log('this.islead:' + this.islead);

                            // ========================================================
                            // console.log('this.grpLevel===' + this.grpLevel);
                            if ((this.grpLevel === 1) || this.grpLevel >= 2) {
                                this.getCategory();
                            }
                            if (this.grpLevel >= 3) {
                                this._rest.getAllLevelOneAndLevelTwoUser(this.clientId).subscribe((res5) => {
                                    this.respObject = res5;
                                    if (this.respObject.success) {
                                        this.isError = false;
                                        // // console.log(this.respObject);
                                        this.respObject.details.unshift({ id: 0, name: 'Select Analyst' });
                                        this.users = this.respObject.details;
                                        // this.userSelected = 0;
                                    } else {
                                        this.notifier.notify('error', this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                    // this.isError = true;
                                    // this.errorMessage = this.messageService.SERVER_ERROR;
                                });
                            }
                            // ==========================================================
                            // end user and l1 => dash bord detls
                            //   l1 lead => getDashBoardDtlsForTeamLead
                            //   l2 -l5 new api => getDashBoardDtlsForLeader
                            this.getDynamicMenu_new();
                        } else {

                        }
                    });

                } else {
                    this.isLoading = false;
                }
            });
        } else {
            this.ticketTypeLoaded = true;
            this.isLoading = false;
        }
        if (this.grpLevel === 0 && this.grpLevel !== undefined) {
            this.isLabel0 = true;
        } else if (this.grpLevel === 1 && this.grpLevel !== undefined) {
            this.isLabel1 = true;
        } else if (this.grpLevel === 2 && this.grpLevel !== undefined) {
            this.isLabel2 = true;
        } else if (this.grpLevel >= 3 && this.grpLevel !== undefined) {
            this.isLabel3 = true;
        } else {
            this.isAdmin = true;
        }
    }

    getDynamicMenu_new() {
        this.isLoading = true;
        const wstorage = this.messageService.getWorkspace();
        if (wstorage !== null) {
            // this.workType = wstorage;
            let matched = false;
            for (let i = 0; i < this.workspaces.length; i++) {
                if (this.workspaces[i].id === wstorage) {
                    this.workType = wstorage;
                    matched = true;
                    break;
                }
            }
            if (!matched) {
                this.workType = this.workspaces[0].id;
            }
        } else {
            this.workType = this.workspaces[0].id;
        }
        this.messageService.setWorkspace(this.workType);
        this._rest.getUrlBySupportGroup(this.clientId, this.userGroupId, this.ticketType).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.showScheduleTicket = true;
                this.showCreateTicket = true;
                this.showFaq = true;
                this.showSearch = true;
                this.urlKeys = this.respObject.details;
                for (let i = 0; i < this.urlKeys.length; i++) {
                    if (this.urlKeys[i].url_id === this.CREATE_TICKET_URL_KEY_ID) {
                        this.showCreateTicket = false;
                    } else if (this.urlKeys[i].url_id === this.SCHEDULE_TICKET_URL_KEY_ID) {
                        this.showScheduleTicket = false;
                    } else if (this.urlKeys[i].url_id === this.FAQ_URL_KEY_ID) {
                        this.showFaq = false;
                    } else if (this.urlKeys[i].url_id === this.SEARCH_URL_KEY_ID) {
                        this.showSearch = false;
                    }
                }
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this._rest.getDynamicMenuTicketTypeWise(this.clientId, this.ticketType,
            this.messageService.getUserId(), 1, this.userGroupId, this.workType).subscribe((res2) => {
                this.respObject = res2;
                // // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                    this.tilesData = [];
                    this.selectedData = this.respObject.details;
                    this.isLoading = false;
                    this.tilesData = this.selectedData;
                    for (let i = 0; i < this.selectedData.length; i++) {
                        // this._rest.getDashBoardDtls_new(this.clientId, this.userGroupId, this.ticketType,
                        if (this.typeSeq === 2) {
                            this._rest.getDynamicTotCountMenuTicketDtls_new(this.clientId, this.userGroupId, this.ticketType, this.typeSeq,
                                this.selectedData[i].fid, this.categorySelected, this.userSelected).subscribe((res) => {
                                    this.respObject = res;
                                    // // console.log('data--Done=======', this.respObject);
                                    if (this.respObject.success) {
                                        document.getElementById('loader_' + this.respObject.details[0].id).hidden = true;
                                        document.getElementById('count_' + this.respObject.details[0].id).innerText = this.respObject.details[0].value;
                                    } else {
                                        this.notifier.notify('error', this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                });
                        } else {
                            this._rest.getDynamicTotCountMenuTicketDtls(this.clientId, this.userGroupId, this.ticketType,
                                this.selectedData[i].fid, this.categorySelected, this.userSelected).subscribe((res) => {
                                    this.respObject = res;
                                    // // console.log('data--Done=======', this.respObject);
                                    if (this.respObject.success) {
                                        document.getElementById('loader_' + this.respObject.details[0].id).hidden = true;
                                        document.getElementById('count_' + this.respObject.details[0].id).innerText = this.respObject.details[0].value;
                                    } else {
                                        this.notifier.notify('error', this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                });
                        }
                    }
                    this._rest.checkOfflineDashNotification(this.clientId, this.userGroupId,
                        this.messageService.getUserId(), this.ticketType, 1).subscribe((res) => {
                            this.respObject = res;
                            if (this.respObject.success) {
                                const result = this.respObject.details;
                                // this.menus = this.respObject.details;
                                for (let i = 0; i < result.length; i++) {
                                    const menuId = result[i].noti_type;
                                    const displayelem = document.getElementById('display_' + menuId);
                                    if (displayelem !== undefined && displayelem !== null) {
                                        displayelem.classList.remove('none');
                                    }

                                }
                            }
                        });
                    // // console.log('++++++++++++', JSON.stringify(this.tilesData));
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
    }

    filter() {
        this._rest.getSubClientType(this.masterClientId).subscribe((res: any) => {
            if (res.success) {
                if (res.details.length > 0) {
                    res.details.unshift({ id: 0, NAME: 'Select Sub Client' });
                    this.subClients = res.details;
                    this.clientSelected = 0;
                    this.openClientModal();
                }
                // else {
                //   this.startLoading();
                // }
            } else {
                this.notifier.notify('error', res.errorMessage);
            }
        });
    }

    openClientModal() {
        this.allSelected = false;
        this.dialogRef = this.dialog.open(this.clientSelect, {
            width: '400px'
        });
    }

    getSubClientDetails() {
        if (this.clientSelected > 0 && this.groupSelected > 0) {
            this.masterClientId = this.clientId;
            this.masterSupportGroupId = this.userGroupId;
            this.clientId = this.clientSelected;
            this.userGroupId = this.groupSelected;
            this.dialogRef.close();
            this.onPageLoad();
        }
    }

    onGroupChange(selectedIndex: any) {
        this.groupName = this.groups[selectedIndex].name;
        this.grpLevel = this.groups[selectedIndex].group_level;
        if (this.clientSelected > 0 && this.groupSelected > 0) {
            this.allSelected = true;
        } else {
            this.allSelected = false;
        }
    }

    onSubClientChange() {
        this.groups = [];
        this.groupSelected = 0;
        if (this.clientSelected > 0 && this.groupSelected > 0) {
            this.allSelected = true;
        } else {
            this.allSelected = false;
        }
        this._rest.getSupportGroupByClientId(this.clientSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.respObject.details.unshift({ id: 0, name: 'Select Support Group' });
                this.groups = this.respObject.details;
                this.groupSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
        });
    }

    createTicket() {
        sessionStorage.setItem('dd', JSON.stringify({
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        // this.route.navigate(['ticket/createTicketL&T']);
        if (this.messageService.createUrl !== undefined && this.messageService.createUrl !== null) {
            this.messageService.changeRouting(this.messageService.createUrl);
        }
    }

    onButtonChange(selectedButton) {
        // console.log('+++++++++++++++++', selectedButton.value.seq, selectedButton.value.id, this.grpLevel);
        this.ticketType = selectedButton.value.id;
        this.typeSeq = selectedButton.value.seq;
        this.messageService.saveMenuData({
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        });
        if (this.grpLevel === 0 || this.typeSeq === 2) {
            this.workspaces = [{ id: '1', name: 'My Workspace' }];
        } else {
            this.workspaces = [{ id: '1', name: 'My Workspace' }, { id: '2', name: 'Team Workspace' }];
        }
        // this.workType = '1';
        // sessionStorage.setItem('dd', JSON.stringify({
        //     type: this.ticketType,
        //     seq: this.typeSeq,
        //     user: this.userSelected,
        //     cat: this.categorySelected
        // }));
        this.getCategory();
        this.getDynamicMenu_new();
    }

    getCategory() {
        this._rest.getCategoryListSupportGroupWise(this.userGroupId, this.clientId,
            this.ticketType).subscribe((res4) => {
                this.respObject = res4;
                if (this.respObject.success) {
                    this.respObject.details.unshift({ id: 0, name: 'Select Team' });
                    this.categories = this.respObject.details;
                    this.categorySelected = 0;
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.isError = true;
                // this.errorMessage = this.messageService.SERVER_ERROR;
            });
    }

    goto(fid) {
        this.messageService.clientId = this.clientId;
        const groupdata = {
            'groupId': this.userGroupId,
            'grpName': this.groupName,
            'level': this.grpLevel
        };
        sessionStorage.setItem('grp', JSON.stringify({
            groupId: this.userGroupId,
            grpName: this.groupName,
            level: this.grpLevel,
        }));
        // console.log('userGroups11111===========' + JSON.stringify(groupdata));
        // this.messageService.groupId.unshift(groupdata);
        sessionStorage.setItem('dd', JSON.stringify({
            id: fid,
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        // console.log(JSON.stringify(this.messageService.groupId));
        if (this.messageService.viewUrl !== undefined && this.messageService.viewUrl !== null) {
            this.messageService.changeRouting(this.messageService.viewUrl);
        }
        // this.route.navigate(['ticket/viewTicketL&TSSC']);
    }

    onSelectGroup() {
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.isLabel3 = false;
        this.islead = false;
        this.ticketTypeLoaded = true;
        if (this.userGroupSelected !== 0) {
            this.userGroupId = this.userGroupSelected;
            for (let i = 0; i < this.userGroups.length; i++) {
                if (this.userGroups[i].groupId === this.userGroupId) {
                    this.groupName = this.userGroups[i].grpName;
                    this.grpLevel = this.userGroups[i].level;
                }
            }
            if (this.grpLevel === 0 && this.grpLevel !== undefined) {
                this.isLabel0 = true;
                this.workType = '1';
                this.messageService.setWorkspace(this.workType);
            } else if (this.grpLevel === 1 && this.grpLevel !== undefined) {
                this.isLabel1 = true;
            } else if (this.grpLevel === 2 && this.grpLevel !== undefined) {
                this.isLabel2 = true;
            } else if (this.grpLevel >= 3 && this.grpLevel !== undefined) {
                this.isLabel3 = true;
            } else {
                this.isAdmin = true;
            }
            this.messageService.saveSupportGroup({
                groupId: this.userGroupId,
                grpName: this.groupName,
                level: this.grpLevel
            });
            this.onPageLoad();
        }
    }

    onSelectCategory() {
        this.userSelected = 0;
        this.getDynamicMenu_new();
    }

    onSelectUser() {
        this.categorySelected = 0;
        this.getDynamicMenu_new();
    }

    ngOnDestroy() {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }

        if (this.ticketSub) {
            this.ticketSub.unsubscribe();
        }
        if (this.dashboardSubscribe) {
            this.dashboardSubscribe.unsubscribe();
        }
    }

    goTofaq() {
        // this.route.navigate(['ticket/faq']);
        if (this.messageService.faqUrl !== undefined && this.messageService.faqUrl !== null) {
            this.messageService.changeRouting(this.messageService.faqUrl);
        }
    }

    goToSearch() {
        sessionStorage.setItem('dd', JSON.stringify({
            type: this.ticketType,
            user: this.userSelected,
            cat: this.categorySelected,
            seq: this.typeSeq,
        }));
        // this.route.navigate(['ticket/search']);
        if (this.messageService.searchUrl !== undefined && this.messageService.searchUrl !== null) {
            this.messageService.changeRouting(this.messageService.searchUrl);
        }
    }

    goToScheduleTicket() {
        if (this.messageService.scheduleTicketUrl !== undefined && this.messageService.scheduleTicketUrl !== null) {
            this.messageService.changeRouting(this.messageService.scheduleTicketUrl);
        }
    }

    onWorkTypeChange() {
        // this.wor
        this.messageService.setWorkspace(this.workType);
        this.getDynamicMenu_new();
    }
}
